import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=5ec5b938&scoped=true&"
import script from "./ProductEditor.vue?vue&type=script&lang=ts&"
export * from "./ProductEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./ProductEditor.vue?vue&type=style&index=1&id=5ec5b938&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5ec5b938",
  null
  
)

export default component.exports